import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'
import type { Categoria } from '../../core/api/types'
import { FLEET_ICON_SIZES, fleetIconUrl, type FleetIconSize } from '../fleetTipos'
import { useI18n } from '../../core/i18n/useI18n'
import { categoryLabel } from '../categoryLabels'

interface Props {
  category: Categoria | null | undefined
  size?: FleetIconSize
  sx?: SxProps<Theme>
}

/** Desenho do veículo pelo tipo cadastrado na frota. */
export function FleetIcon({ category, size = 'inline', sx }: Props) {
  const { t } = useI18n()
  const label = category ? categoryLabel(category, t) : t('category.none')
  return (
    <Box
      component="img"
      src={fleetIconUrl(category?.code)}
      alt={label}
      title={label}
      draggable={false}
      sx={{ ...FLEET_ICON_SIZES[size], objectFit: 'contain', flexShrink: 0, verticalAlign: 'middle', ...sx }}
    />
  )
}

/** Ícone + placa, o par que aparece em grade, chip, resumo e diálogo. Sem placa
 *  mostra o texto de vazio recebido, mantendo o alinhamento da coluna. */
export function FleetPlate({
  plate,
  category,
  size = 'inline',
  empty = '—',
  sx,
}: Props & { plate: string | null | undefined; empty?: string }) {
  if (!plate) return <Box component="span" sx={{ color: 'text.disabled' }}>{empty}</Box>
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, minWidth: 0, ...sx }}>
      <FleetIcon category={category} size={size} />
      <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{plate}</Box>
    </Box>
  )
}
